import { Controller } from "react-hook-form";
import CustomNumberInput from "../../../ui/CustomNumberInput/CustomNumberInput";
import { exceedsBalance, formatKES } from "../../../../utils/transactionutils";
import useLipaBidhaaStore from "../../../../stores/lipaBidhaaStore";

export function AmountField({
  control,
  amountValidator,
  walletBalance,
  isBalanceError,
  isLoading,
}) {
  return (
    <div className="space-y-1">
      <Controller
        name="amount"
        control={control}
        rules={{
          validate: {
            format: (v) => amountValidator(v) ?? true,
            balance: (v) =>
              walletBalance != null && exceedsBalance(v, walletBalance)
                ? `Insufficient balance. Available: ${formatKES(walletBalance)}`
                : true,
          },
        }}
        render={({ field, fieldState }) => (
          <CustomNumberInput
            label="Amount (KSh)"
            placeholder="Enter amount"
            withAsterisk
            min={1}
            hideControls
            disabled={isLoading}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
              useLipaBidhaaStore
                .getState()
                .setPaymentDraft({ transactionAmount: value });
            }}
            onBlur={field.onBlur}
            error={fieldState.error?.message}
          />
        )}
      />

      {isBalanceError && (
        <p className="text-xs text-amber-600 px-1">
          Balance unavailable — real-time validation disabled.
        </p>
      )}
    </div>
  );
}
